




































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import moment from 'moment';
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBoxScoreStamp.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue";
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import { BModal, BCarousel, BPopover } from 'bootstrap-vue';
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import { Sheet, SheetField, SheetActivity, FieldActivity, ParamFieldActivity, ScoreStamp, TensakuText } from "../../modules/teacher/SaitenInputScoreStamp";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  inputScale: number
  fieldPadding: number
  fieldMargin: number
  windowHeight: number
  drawMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  base64CorrectImage: string
  tensakuText: string
  tensakuFontSize: number
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isProcessingApi: boolean
  isUpdateConfirmed: boolean
  tensakuNumberOptions: any[]
  fontSizeOptions: any[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  carouselPageIdx: number
  modalIdx: number
  timer: any
  errors: string[]
  scoring_type_name: string
  isShowContextMenu: boolean
  pagePos: Common.Point
  stampPos: Common.Point
  contextButtonWidth: number
  contextButtonHeight: number
  contextScoreRows: any[]
  modeAreaLeft: number
  modeAreaTop: number
  modeAreaWidth: number
  keyCode: string
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  drawColor: string
  DirectionEnum: Readonly<{Horizon: number; Vertical: number;}>
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  isDispCorrectImage: boolean
  correctImageScale: number
  scrollBarSize: number
  saitenBoxMarginTop: number
  is_first_room: boolean
  is_last_room: boolean
  isShowSessionMsg: boolean
  isWarningTimeReached: boolean
  warningDispTime: number
  fontSize: number
  lineHeight: number
  textColor: string
  selectedTensakuText: TensakuText
  isInitialized: boolean
  copiedStamp: any
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
    "text-edit-box": TextEditBox,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
    "text-direction-toggle": TextDirectionToggle,
  },
  setup(props, context){

    const DrawModeEnum = Common.DrawModeEnum;
    const SaitenSortKindEnum = Common.SaitenSortKindEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;
    const DirectionEnum = Common.DirectionEnum;

    const saitenBoxRef = ref([]);
    const modalCorrectImageRef = ref<InstanceType<typeof BModal>>();
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const modalPreviewImageRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      inputScale: 1,
      fieldPadding: 8,
      fieldMargin: 5,
      windowHeight: 0,
      drawMode: DrawModeEnum.None,
      sortKind: SaitenSortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      base64CorrectImage: "",
      tensakuText: "1",
      tensakuFontSize: 30,
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isProcessingApi: false,
      tensakuNumberOptions: new Array<object>(),
      fontSizeOptions: new Array<object>(),
      pcHelpFields: [
        { key: "O・Aキー", img: [require("@/assets/images/keyboard_A.png"), require("@/assets/images/keyboard_O.png")], description: "正答○（KEY入力モードのみ有効）" },
        { key: "X・Fキー", img: [require("@/assets/images/keyboard_F.png"), require("@/assets/images/keyboard_X.png")], description: "誤答✕（KEY入力モードのみ有効）" },
        { key: "1-9キー", img: [require("@/assets/images/keyboard_1.png")], description: "スタンプ得点の得点を編集" },
        { key: "＋キー", img: [require("@/assets/images/keyboard_Plus.png")], description: "現在選択中のスタンプ得点からプラス1点に切り替え" },
        { key: "−キー", img: [require("@/assets/images/keyboard_Minus.png")], description: "現在選択中のスタンプ得点からマイナス1点に切り替え" },
        { key: "Sキー + マウス", img: [require("@/assets/images/keyboard_S.png")], description: "クリックした箇所に得点スタンプを出力" },
        { key: "Tキー + マウス", img: [require("@/assets/images/keyboard_T.png")], description: "クリックした箇所にテキストを出力" },
        { key: "得点スタンプ選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の得点スタンプを削除" },
        { key: "テキスト選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中のテキストを削除" },
        { key: "得点スタンプ・テキスト未選択でBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の切出しの採点内容をクリア" },
        { key: "Dキー + マウス", img: [require("@/assets/images/keyboard_D.png")], description: "自由線" },
        { key: "Eキー + マウス", img: [require("@/assets/images/keyboard_E.png")], description: "消しゴム" },
        { key: "Wキー", img: [require("@/assets/images/keyboard_W.png")], description: "模範解答画像を表示" },
        { key: "エンターキー", img: [require("@/assets/images/keyboard_Enter.png")], description: "次の生徒の切出し画像へ選択を変更" },
        { key: "Mキー", img: [require("@/assets/images/keyboard_M.png")], description: "採点内容を保存して次の設問へ移動" },
        // { key: "Nキー", img: [require("@/assets/images/keyboard_N.png")], description: "採点内容を保存して次の教室へ移動" },
        { key: "Hキー", img: [require("@/assets/images/keyboard_H.png")], description: "保存して戻る" },
        { key: "右矢印キー", img: [require("@/assets/images/keyboard_Arrow_Right.png")], description: "次の生徒の切出し画像へ選択を変更" },
        { key: "左矢印キー", img: [require("@/assets/images/keyboard_Arrow_Left.png")], description: "前の生徒の切出し画像へ選択を変更" },
        { key: "Gキー", img: [require("@/assets/images/keyboard_G.png")], description: "拡大" },
        { key: "Qキー", img: [require("@/assets/images/keyboard_Q.png")], description: "縮小" },
      ],
      tabletHelpFields: [
        { key: "画像上を長押し", img: null, description: "○×・得点スタンプ・テキストを選択するメニューが表示されます。<br>・○ → 次の画像へ遷移します。<br>・× → 次の画像へ遷移します。<br>・得点 → 長押しした箇所に得点スタンプが表示されます。<br>・テキスト → 長押しした箇所にテキストが表示されます。" },
        { key: "得点スタンプを長押し", img: null, description: "得点スタンプを削除します。" },
        { key: "テキストを長押し", img: null, description: "テキストを削除します。" },
        { key: "", img: [require("@/assets/images/keyboard_Arrow_Left_Right.png")], description: "次の画像、前の画像に遷移します。" },
        { key: "", img: [require("@/assets/images/keyboard_ModeArea.png")], description: "メニューボタンがON（緑色）になっている場合は、<font style='color:red'>長押し操作が反映されません。</font><br>ON（緑色）のアイコンを押すと、OFF（グレー）に戻ります。" },
      ],
      carouselPageIdx: 0,
      modalIdx: 0,
      timer: null,
      errors: [],
      scoring_type_name: null,
      isShowContextMenu: false,
      pagePos: new Common.Point(0, 0),
      stampPos: new Common.Point(0, 0),
      contextButtonWidth: 40,
      contextButtonHeight: 30,
      contextScoreRows: [],
      modeAreaLeft: 0,
      modeAreaTop: 0,
      modeAreaWidth: context.root.$store.state.isMobile ? 350 : 430,
      keyCode: "",
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      drawColor: "#FF0000",
      DirectionEnum: Common.DirectionEnum,
      direction: Common.DirectionEnum.Horizon,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.7,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.8,
      separatorSize: 10,
      isDispCorrectImage: true,
      correctImageScale: 50,
      scrollBarSize: 0,
      saitenBoxMarginTop: 15,
      is_first_room: false,
      is_last_room: false,
      isShowSessionMsg: false,
      isWarningTimeReached: false,
      warningDispTime: 9999999,
      fontSize: 20,
      lineHeight: 0,
      textColor: "#FF0000",
      selectedTensakuText: null,
      isInitialized: false,
      copiedStamp: null,
    });

    /************************************************************
     * 選択中のfieldActivity
     ************************************************************/
    const selectedFieldActivity = computed((): FieldActivity | null => {
      const idx = state.selectedIdx;
      if(idx == null || idx < 0 || idx >= state.fieldActivities.length){
        return null;
      }
      return state.fieldActivities[idx];
    });

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedTensakuTextElemId = computed((): any => {
      if(!state.selectedTensakuText || state.selectedIdx == null){
        return null;
      }else{
        return `saiten-box-${state.selectedIdx}-${state.direction}`;
        // return `text-image-${state.direction}-${selectedFieldActivity.value?.id}-${state.selectedTensakuText.idx}`;
      }
    });

    /************************************************************
     * 選択中のテキストスタンプ切り替え SaitenBoxから呼ばれる
     ************************************************************/

    const changeSelectedTensakuText = (tensakuText: TensakuText) => {
      state.selectedTensakuText = tensakuText;
      if(state.selectedTensakuText){
        state.fontSize = tensakuText.font_size;
        state.lineHeight = tensakuText.line_height;
        state.textColor = tensakuText.color;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const size = Common.getTextSize({text: state.selectedTensakuText.text, fontSize: state.selectedTensakuText.font_size, lineHeight: state.selectedTensakuText.line_height, direction: state.selectedTensakuText.direction, defaultText: "テキスト"});
      
      if(state.selectedTensakuText.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedTensakuText.width;
        state.selectedTensakuText.x -= diffW;
      }
      
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText, "テキスト");
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedTensakuText.font_size = state.fontSize;
      state.selectedTensakuText.line_height = state.lineHeight;
      state.selectedTensakuText.color = state.textColor;
      const size = Common.getTextSize({text: state.selectedTensakuText.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.selectedTensakuText.direction, defaultText: "テキスト"});
      
      if(state.selectedTensakuText.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedTensakuText.width;
        state.selectedTensakuText.x -= diffW;
      }
      
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText, "テキスト");
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削テキストスタンプ追加
     ************************************************************/

    const addTensakuText = (param: any) => {
      if(!selectedFieldActivity.value){
        return;
      }
      const size = Common.getTextSize({text: "", fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection, defaultText: "テキスト"});
      const tensakuText = new TensakuText();
      tensakuText.text = ""
      tensakuText.field_activity_id = selectedFieldActivity.value.id;
      tensakuText.idx = selectedFieldActivity.value.tensakuTextIdx++;
      tensakuText.font_size = state.fontSize;
      tensakuText.line_height = 0;
      tensakuText.color = state.textColor;
      tensakuText.x = param.point.x;
      tensakuText.y = param.point.y;
      tensakuText.width = size.width;
      tensakuText.height = size.height;
      tensakuText.direction = context.root.$store.state.textDirection;
      tensakuText.base64_text = Common.createBase64Text(tensakuText, "テキスト");
      
      state.selectedTensakuText = tensakuText;

      selectedFieldActivity.value.tensakuTexts.push(tensakuText);
      selectedFieldActivity.value.isTextEdited = true;
      state.isShowContextMenu = false;
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteTensakuText = (fieldActivityIdx: number, tensakuTextIdx: number) => {
      state.fieldActivities[fieldActivityIdx].tensakuTexts.splice(tensakuTextIdx, 1);
      state.selectedTensakuText = null;
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
      adjustLayout();
      fitToImageArea();
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / (state.mainAreaWidth);
      state.verticalRightWidthPer = e.paneSize[1] / (state.mainAreaWidth);
      adjustLayout();
      fitToImageArea();
    }

    /************************************************************
     * 採点エリアwidth
     ************************************************************/

    const saitenBoxAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == state.DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalRightWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 採点エリアheight
     ************************************************************/

    const saitenBoxAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == state.DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.saitenBoxMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonBottomHeightPer - state.scrollBarSize - state.saitenBoxMarginTop
      }
    });

    /************************************************************
     * 模範解答エリアwidth
     ************************************************************/

    const correctImageAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == state.DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalLeftWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 模範解答エリアheight
     ************************************************************/

    const correctImageAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == state.DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.saitenBoxMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonTopHeightPer - state.scrollBarSize - state.saitenBoxMarginTop
      }
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        fitToImageArea();
      }
    }

    /************************************************************
     * 模範解答imgタグのCSS
     ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.currentSheetField.baseWidth * state.correctImageScale / 100}px`;
      style["height"] = `${state.currentSheetField.baseHeight * state.correctImageScale / 100}px`;
      style["margin-top"] = `${state.saitenBoxMarginTop}px`;
      style["padding-left"] = `${state.fieldPadding}px`;
      style["padding-right"] = `${state.fieldPadding}px`;
      style["padding-bottom"] = `${state.fieldPadding}px`;
      return style;
    });

    /************************************************************
     * コンテキストメニューのボタンStyle
     ************************************************************/

    const contextButtonStyle = computed((): any => {
      return {width: `${state.contextButtonWidth}px`, height: `${state.contextButtonHeight}px`}
    });

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * コンテキストメニューのStyle
     ************************************************************/

    const contextAreaStyle = computed((): any => {
      const padding = 18;
      const rowCnt = state.contextScoreRows.length + 1;
      let colCnt = state.contextScoreRows.map((x: number[]) => x.length).reduce((a,b)=>Math.max(a,b));
      // 部分点数が1の場合、○×ボタンがあるので2列とする
      if(colCnt < 4){
        colCnt = 4;
      }
      return {
        left: `${state.pagePos.x - 10}px`,
        top: `${state.pagePos.y - (state.contextButtonHeight * rowCnt + padding * 2) + 10}px`,
        width: `${state.contextButtonWidth * colCnt + padding * 2}px`,
        height: `${state.contextButtonHeight * rowCnt + padding * 2}px`,
        padding: `${padding}px`,
      }
    });

    /************************************************************
     * ショートカットキー使用可否判定
     ************************************************************/

    const isShortcutEditable = computed((): any => {
      return !state.isProcessingApi && !context.root.$store.state.isShowingMsgBox;
    });

    /************************************************************
     * モーダル表示対象の答案画像
     ************************************************************/

    const base64PreviewImages = computed((): any => {
      return state.fieldActivities[state.modalIdx].base64PreviewImages;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const imageArea = document.getElementById("image-area");
      const tableArea = document.getElementById("table-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        state.mainAreaHeight = (windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5);
        state.mainAreaWidth = windowWidth - tableArea.offsetWidth;
        imageArea.style.height = `${state.mainAreaHeight}px`;
      }

      // 生徒一覧表示エリアの高さを画面サイズに合わせる
      if(tableArea != null && footerArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5) + "px";
        // tableArea.style.width = (windowWidth - state.mainAreaWidth - 20) + "px";
      }

      // 添削ボタンエリアの座標リセット
      const iconDirectionH = document.getElementById("icon-direction-h")
      const tensakuButtonArea = document.getElementById("tensaku-button-area");
      state.modeAreaTop = 5;
      state.modeAreaLeft =  iconDirectionH.getBoundingClientRect().left - tensakuButtonArea.offsetWidth - 10;
    };

    /************************************************************
     * 倍率を加味した切り出し画像のWidth
     ************************************************************/

    const fieldImageWidth = computed((): any => {
      return state.currentSheetField.baseWidth * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのWidth
     ************************************************************/

    const fieldWrapWidth = computed((): any => {
      return fieldImageWidth.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 倍率を加味した切り出し画像のHeight
     ************************************************************/

    const fieldImageHeight = computed((): any => {
      return state.currentSheetField.baseHeight * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのHeight
     ************************************************************/

    const fieldWrapHeight = computed((): any => {
      return fieldImageHeight.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 切り出し画像エリア内に画像が全て収まるように整形
     ************************************************************/

    const fitToImageArea = () => {
      // 採点エリアの倍率設定
      let scaleW = (saitenBoxAreaWidth.value - (state.fieldMargin * 2) - (state.fieldPadding * 2)) / (state.currentSheetField.baseWidth);
      let scaleH = (saitenBoxAreaHeight.value - (state.fieldPadding * 2)) / (state.currentSheetField.baseHeight);
      state.inputScale = (scaleW > scaleH ? scaleH : scaleW) * 100;

      // 模範解答エリアの倍率設定
      scaleW = (correctImageAreaWidth.value) / (state.currentSheetField.baseWidth);
      scaleH = (correctImageAreaHeight.value) / (state.currentSheetField.baseHeight);
      state.correctImageScale = (scaleW > scaleH ? scaleH : scaleW) * 100;
    }

    /************************************************************
     * 拡大
     ************************************************************/

    const scaleUp = () => {
      blur();
      state.inputScale += 5;
    };

    /************************************************************
     * 縮小
     ************************************************************/

    const scaleDown = () => {
      blur();
      if(state.inputScale > 10){
        state.inputScale -= 5;
      }
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const showModalCorrectImage = () => {
      blur();
      state.isDispCorrectImage = !state.isDispCorrectImage;
      context.root.$nextTick(() => {
        fitToImageArea();
      });
      // modalCorrectImageRef.value.show();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (idx: number) => {
      blur();
      state.modalIdx = idx;

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      state.carouselPageIdx = 0;
      modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async () => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const student_id = state.fieldActivities[state.modalIdx].sheetActivity.student_id;
      await http.get(`/api/teacher/saiten_input/download_preview_image/${state.sheet_id}/${student_id}/${state.carouselPageIdx + 1}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          state.fieldActivities[state.modalIdx].base64PreviewImages.push(x);
        });
      })
      .catch(async error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = async () => {
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.currentSheet.page_count - 1;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = async () => {
      if(state.carouselPageIdx + 1 < state.currentSheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      
      if(state.modalIdx > 0){
        state.modalIdx--;
      }else{
        state.modalIdx = state.fieldActivities.length - 1;
      }

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      if(state.modalIdx + 1 < state.fieldActivities.length){
        state.modalIdx++;
      }else{
        state.modalIdx = 0;
      }
      
      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number) => {
      blur();
      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if(sortKind == SaitenSortKindEnum.No){
        state.fieldActivities.sort((a, b) => {
          if(a.examinee.student_code > b.examinee.student_code) {
            return 1;
          }else{
            return -1;
          }
        });
      }else if(sortKind == SaitenSortKindEnum.CorrectState){
        state.fieldActivities.sort((a, b) => {
          if(a.score != b.score){
            return (a.score - b.score) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }else{
        state.fieldActivities.sort((a, b) => {
          if(a.base64Image.length != b.base64Image.length){
            return (a.base64Image.length - b.base64Image.length) * -1;
          }
          return a.sheetActivity.student_id - b.sheetActivity.student_id;
        });
      }
    };

    /************************************************************
     * 添削モードエリアドラッグ系処理
     ************************************************************/

    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 8;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeDrawMode = (drawMode: number) => {
      blur();
      if(state.drawMode == drawMode){
        state.drawMode = DrawModeEnum.None;
      }else{
        state.drawMode = drawMode;
      }
    }

    /************************************************************
     * 採点BOXからのemitによる採点モード切り替え
     ************************************************************/

    const changeDrawModeBySaitenBox = (drawMode: number) => {
      state.drawMode = drawMode;
    }

    /************************************************************
     * 正答or誤答採点
     ************************************************************/

    const updateCorrectState = async (correct_state: number, score: number) => {

      state.isShowContextMenu = false;

      if(!selectedFieldActivity.value){
        return;
      }
      selectedFieldActivity.value.scoreStamps = [];
      setCorrect(selectedFieldActivity.value, correct_state, score);

      if(state.selectedIdx + 1 == state.fieldActivities.length){
        if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
          setTimeout(async () => {
            // 次の設問へ
            if(state.next_sheet_field != null){          
              toNextField();
            }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, "最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
              sendSaitenData(null, null);
            }
          }, 100);
        }
      }else{
        state.selectedIdx++;
        scrollTableArea();
      }
    }

    /************************************************************
     * 表示対象の切り出し画像切り替え
     ************************************************************/

    const changeSelectedIdx = async (idx: number) => {
      state.selectedIdx = idx;
    }

    /************************************************************
     * 次の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxUp = () => {
      if(state.selectedIdx + 1 < state.fieldActivities.length){
        state.selectedIdx++;
        scrollTableArea();
      }
    }

    /************************************************************
     * 前の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxDown = () => {
      if(state.selectedIdx - 1 >= 0){
        state.selectedIdx--;
        scrollTableArea();
      }
    }

    /************************************************************
     * コンテキストメニュー表示
     ************************************************************/

    const showContextMenu = (pagePos: Common.Point, stampPos: Common.Point) => {
      state.pagePos = pagePos;
      state.stampPos = stampPos;
      state.isShowContextMenu = true;
    }

    /************************************************************
     * コンテキストメニュー非表示切り替え
     ************************************************************/

    const hideContextMenu = () => {
      state.isShowContextMenu = false;
    }

    const contextMenuMouseDown = (e: MouseEvent) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyUp = (e:KeyboardEvent) => {
      state.keyCode = "";

      if(e.key == "e" || e.key == "d"){
        // 現在描画中のcanvasを保持
        saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
          if(x.idx == state.selectedIdx){
            x.resetDrawingByKeyUp();
          }
        });
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyDown = async (e: KeyboardEvent) => {

      state.keyCode = "";
      
      // API通信中は処理しない
      if(!isShortcutEditable.value){
        return;
      }

      // メモのtextareaがフォーカスされている場合は処理しない
      if(document.activeElement.nodeName.toLowerCase() == "textarea"){
        return;
      }

      if(e.key == "e" || e.key == "d" || e.key == "s" || e.key == "t"){
        state.keyCode = e.key;
      }

      e.preventDefault();
      if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key)){
        // 部分点プルダウン切り替え
        let score = state.selectedScore < 0 ? -(Number(e.key)) : Number(e.key);
        if(state.scoreOptions.map((x: any) => x.value).includes(score)){
          state.selectedScore = score;
        }
      }else if(e.key == ";" || e.key == "+"){
        // 部分点プラス
        if(state.selectedScore < state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == -1 ? 1 : state.selectedScore + 1;
        }
      }else if(e.key == "-"){
        // 部分点マイナス
        if(state.selectedScore > -state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == 1 ? -1 : state.selectedScore - 1;
        }
      }else if(e.key == "x" || e.key == "f"){
        // 誤答採点
        await updateCorrectState(CorrectStateEnum.Gotou, 0);
      }else if(e.key == "o" || e.key == "a"){
        // 誤答採点
        await updateCorrectState(CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(["Enter", "ArrowLeft", "ArrowRight"].indexOf(e.key) != -1){
        
        let nextIdx = state.selectedIdx;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の切り出しへ
          nextIdx = state.selectedIdx - 1;
          if(nextIdx < 0){
            return;
          }
        }else if(e.key == "ArrowRight" || e.key == "Enter"){
          
          // 最終切り出しでエンターor右矢印キーの場合、次の設問へ移動
          // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
          if(e.key == "Enter" && modalCorrectImageRef.value.$data.isShow){
            modalCorrectImageRef.value.hide();
          }else if(e.key == "Enter" && modalAddtionRef.value.$data.isShow){
            modalAddtionRef.value.hide();
          }else if(state.selectedIdx + 1 == state.fieldActivities.length){
            
            // 最終切り出しでEnter or 右矢印は次の設問へ
            if(state.next_sheet_field != null){          
              toNextField();
            }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, "最後の設問を採点しました。一覧へ移動します。よろしいですか？")){
              sendSaitenData(null, null);
            }
          }else{
            // 右矢印 次の切り出しへ
            nextIdx =  state.selectedIdx + 1;
          }
        }
        state.selectedIdx = nextIdx;
        scrollTableArea();

      }else if(e.key == "w"){
        // Wキー 模範解答モーダル表示
        state.isDispCorrectImage = !state.isDispCorrectImage;
        context.root.$nextTick(() => {
          fitToImageArea();
        });

        // modalCorrectImageRef.value.show();
      }else if(e.key == "Backspace"){
        if(!selectedFieldActivity.value){
          return;
        }
        const activeScoreStamps = selectedFieldActivity.value.scoreStamps.filter(x => x.isActive);
        if(activeScoreStamps.length > 0){
          // 得点スタンプ削除
          activeScoreStamps.forEach(x => {
            const idx = selectedFieldActivity.value.scoreStamps.indexOf(x);
            deleteScoreStamp(state.selectedIdx, idx);
          }); 
        }else if(state.selectedTensakuText){
          const idx = selectedFieldActivity.value.tensakuTexts.indexOf(state.selectedTensakuText);
          deleteTensakuText(state.selectedIdx, idx);
          selectedFieldActivity.value.isTextEdited = true;
        }else{
          // 採点内容クリア
          selectedFieldActivity.value.correct_state = null;
          selectedFieldActivity.value.score = null;
          selectedFieldActivity.value.scoreStamps = [];
          // 選択中の切り出しのcanvasをクリア
          saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
            if(x.idx == state.selectedIdx){
              x.clearCanvas();
            }
          });
        }
      }else if(e.key == "n"){
        // if(state.next_room_sheet_field != null){          
        //   toNextSheet();
        // }
      }else if(e.key == "m"){
        if(state.next_sheet_field != null){          
          toNextField();
        }
      }else if(e.key == "q"){
        // Qキー 縮小
        state.inputScale -= 10;
      }else if(e.key == "g"){
        // Gキー 拡大
        state.inputScale += 10;
      }else if(e.key == "h"){
        // Hキー 保存して戻る
        toSaitenListWithSendSaitenData();
      }else if(e.key == "c" && e.ctrlKey){
        const activeScoreStamps = selectedFieldActivity.value ? selectedFieldActivity.value.scoreStamps.filter(x => x.isActive) : [];
        if(activeScoreStamps.length > 0){
          // 得点スタンプコピー
          const copiedStamp = new ScoreStamp();
          copiedStamp.score = activeScoreStamps[0].score;
          copiedStamp.x = activeScoreStamps[0].x;
          copiedStamp.y = activeScoreStamps[0].y;
          copiedStamp.width = activeScoreStamps[0].width;
          copiedStamp.height = activeScoreStamps[0].height;
          copiedStamp.color = activeScoreStamps[0].color;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "得点スタンプをコピーしました。");
        }else if(state.selectedTensakuText){
          // テキストスタンプコピー
          const copiedStamp = new TensakuText();
          copiedStamp.text = state.selectedTensakuText.text;
          copiedStamp.font_size = state.selectedTensakuText.font_size;
          copiedStamp.line_height = state.selectedTensakuText.line_height;
          copiedStamp.color = state.selectedTensakuText.color;
          copiedStamp.x = state.selectedTensakuText.x;
          copiedStamp.y = state.selectedTensakuText.y;
          copiedStamp.width = state.selectedTensakuText.width;
          copiedStamp.height = state.selectedTensakuText.height;
          copiedStamp.direction = state.selectedTensakuText.direction;
          copiedStamp.base64_text = state.selectedTensakuText.base64_text;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "添削テキストをコピーしました。");
        }
      }else if(e.key == "v" && e.ctrlKey && state.copiedStamp != null){
        if(!selectedFieldActivity.value){
          return;
        }
        state.selectedTensakuText = null;
        selectedFieldActivity.value.scoreStamps.forEach(x => x.isActive = false);
        if(state.copiedStamp instanceof ScoreStamp){
          // 得点スタンプペースト(参照を切るために一旦json化して別インスタンスとしてペースト)
          const pasteStamp = JSON.parse(JSON.stringify(state.copiedStamp)) as ScoreStamp;

          // 同じ座標・サイズ・点数の得点スタンプが出力済みの場合、確認メッセージを表示
          // 出力しても見た目上、完全に重なってしまい誤ったペーストの場合気づかない可能性があるため
          // 例> 1点スタンプ出力⇒コピー⇒同じ切出しにペースト⇒完全に重なった状態でペーストされて見た目変わらずなのに得点だけ変わるのでバグと勘違いされる
          if(selectedFieldActivity.value.scoreStamps.filter(x => x.x == pasteStamp.x && x.y == pasteStamp.y && x.score == pasteStamp.score).length > 0){
            if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "同じ位置・サイズ・点数の得点スタンプが既に出力されています。得点スタンプをペーストしますか？")){
              return;
            }
          }

          pasteStamp.idx = selectedFieldActivity.value.scoreStampIdx++;
          pasteStamp.field_activity_id = selectedFieldActivity.value.id;
          pasteStamp.isActive = true;
          selectedFieldActivity.value.scoreStamps.push(pasteStamp);
          calcScoreByScoreStamp(state.selectedIdx);
          Common.showToast(context.root.$bvToast, "得点スタンプをペーストしました。");
        }else if(state.copiedStamp instanceof TensakuText){
          // テキストスタンプペースト(参照を切るために一旦json化して別インスタンスとしてペースト)
          const pasteStamp = JSON.parse(JSON.stringify(state.copiedStamp)) as TensakuText;
          pasteStamp.field_activity_id = selectedFieldActivity.value.id;
          pasteStamp.idx = selectedFieldActivity.value.tensakuTextIdx++;
          selectedFieldActivity.value.tensakuTexts.push(pasteStamp);
          state.selectedTensakuText = pasteStamp;
          selectedFieldActivity.value.isTextEdited = true;
          Common.showToast(context.root.$bvToast, "添削テキストをペーストしました。");
        }
      }
    };

    /****************************************
     * 一覧スクロール
     ****************************************/

    const scrollTableArea = () => {
      if(state.selectedIdx == null){
        return;
      }
      const scrollArea = document.getElementById("table-area");
      const trArea = document.getElementById(`tr-${state.selectedIdx}`);
      const labelScoringtype = document.getElementById("label-scoring-type");

      const scrollAreaHeight = scrollArea.offsetHeight - labelScoringtype.offsetHeight * 2;
      const scrollAreaTop = scrollArea.scrollTop - labelScoringtype.offsetHeight * 2;
      const scrollAreaBottom = scrollAreaTop + scrollAreaHeight;
      const trTop = trArea.offsetTop;
      const trBottom = trArea.offsetTop + trArea.offsetHeight;
      
      if(state.selectedIdx == 0){
        scrollArea.scrollTop = 0;
      }else if(scrollAreaTop > trTop){
        scrollArea.scrollTop -= trArea.offsetHeight;
      }else if(scrollAreaBottom < trBottom){
        scrollArea.scrollTop += trArea.offsetHeight;
      }
    }

    /************************************************************
     * 採点内容変更フラグ更新
     * 入試・模試で2次採点以降に採点内容を変更した場合にフラグを立てる
     ************************************************************/

    const setCorrect = (fieldActivity: FieldActivity, correct_state: number, score: number) => {
      fieldActivity.correct_state = correct_state;
      fieldActivity.score = score;
    }

    /************************************************************
     * 得点スタンプ編集有無判定
     ************************************************************/

    const isStampChanged = (fieldActivity: FieldActivity) => {
      return JSON.stringify(fieldActivity.scoreStamps) != JSON.stringify(fieldActivity.scoreStampCaches);
    }

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrect = async () => {
      blur();
      if(!window.confirm("採点内容を画面表示時点の状態にクリアします。よろしいですか？")){
        return;
      }
      window.location.reload();
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = async () => {
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "採点内容を保存して採点一覧に戻ります。よろしいですか？")){
        return;
      }
      sendSaitenData(null, null);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "前の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.prev_sheet_field);
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "次の設問へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(Number(state.sheet_id), state.next_sheet_field);
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = async () => {
      blur();
      const msg = state.is_last_room ? "先頭の教室に戻ります。よろしいですか？" : "次の教室へ移動します。よろしいですか？";
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, msg)){
          return;
        }
        sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field);
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = async () => {
      blur();
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "前の教室へ移動します。よろしいですか？")){
        return;
      }
      sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field);
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_input/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}.png`, x.base64Canvas, {base64: true});
        }

        if(x.isTextEdited){
          x.tensakuTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`tensaku_text_${y.field_activity_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
        const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache).map(x => x.id);
        const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
        const tensakuUpdatedIds = state.fieldActivities.filter(x => x.isTextEdited).map(x => x.id);

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));
        fd.append("tensaku_updated_ids", JSON.stringify(tensakuUpdatedIds));
        fd.append("scoring_type", `${state.currentSheetField.scoring_type}`);

        await http.post(`/api/teacher/saiten_input/update/${state.sheet_id}`, fd).then(async response => {
          if(next_sheet_id != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_seigo/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(err => {});
              context.root.$nextTick(() => {
                window.location.reload();
              });
            }
          }else{
            // 採点一覧へ戻る
            context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(err => {});
          }
        })
        .catch(error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      await http.get(`/api/teacher/saiten_input/check_saiten_lock/${state.sheet_field_id}`).then(response => {
        confirmMessage = response.data.confirm_message;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!window.confirm(confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      const param = {
        target_examinee_ids: context.root.$store.state.saitenTargetExamineeIds,
        sheet_id: state.sheet_id,
        sheet_field_id: state.sheet_field_id,
      };
      
      await http.post(`/api/teacher/saiten_input/search_init_data`, param).then(response => {
        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any) => new FieldActivity(x, response.data.sheet_activities, response.data.examinees, response.data.base64_canvas_hash_array, state.currentSheet.page_count, response.data.score_stamps, response.data.tensaku_texts));
        state.base64CorrectImage = response.data.base64_correct_image;
        state.next_room_sheet_id = response.data.next_room_sheet_id;
        state.next_room_sheet_field =  response.data.next_room_sheet_field ? new SheetField(response.data.next_room_sheet_field, response.data.buff_size) : null;
        state.prev_room_sheet_id = response.data.prev_room_sheet_id;
        state.prev_room_sheet_field = response.data.prev_room_sheet_field ? new SheetField(response.data.prev_room_sheet_field, response.data.buff_size) : null;
        state.prev_sheet_field = response.data.prev_sheet_field ? new SheetField(response.data.prev_sheet_field, response.data.buff_size) : null;
        state.next_sheet_field = response.data.next_sheet_field ? new SheetField(response.data.next_sheet_field, response.data.buff_size) : null;
        state.is_first_room = response.data.is_first_room;
        state.is_last_room = response.data.is_last_room;
        state.warningDispTime = Date.now() + response.data.warning_disp_time;
        state.selectedIdx = 0;
        state.processingTime = 0;
        state.carouselPageIdx = state.currentSheetField.page -1;
        state.scoring_type_name = Common.GetScoringTypeNameByCode(state.currentSheetField.scoring_type);

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = -state.currentSheetField.allot; i <= state.currentSheetField.allot; i++){
          if(i != 0){
            state.scoreOptions.push({value: i, text: `${i}点`});
          }
        }

        // 部分点プルダウン初期選択値設定
        state.selectedScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 1 : -1;

        // コンテキストメニューの部分点ボタンバインド用配列生成
        const contextScoreRows = [];
        let contextScoreCols = [];
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(-i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        state.contextScoreRows = contextScoreRows;

        // 数字入力プルダウン生成
        state.tensakuNumberOptions = new Array<any>();
        for(let i = -100; i < 101; i++){
          state.tensakuNumberOptions.push({value: i, text: `${i}`});
        }

        // フォントサイズプルダウン生成
        state.fontSizeOptions = new Array<any>();
        for(let i = 5; i < 101; i++){
          state.fontSizeOptions.push({value: i, text: i});
        }
        
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `レポート情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if(!state.isWindowEventAdded){
        window.addEventListener("keyup", keyUp);
        window.addEventListener("keydown", keyDown);
        window.addEventListener("resize", adjustLayout);
      }

      state.direction = state.currentSheetField.baseWidth > state.currentSheetField.baseHeight ? state.DirectionEnum.Horizon : state.DirectionEnum.Vertical;

      if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
        // 採点済みデータありの場合は○×順表示で表示
        changeSortKind(SaitenSortKindEnum.CorrectState);
      }else{
        // 全件未採点の場合は番号順で表示
        changeSortKind(SaitenSortKindEnum.No);
      }

      state.isInitialized = true;

      adjustLayout();
      state.processingTime = 0;
      state.isShowSessionMsg = false;
      state.isWarningTimeReached = false;
      state.timer = setInterval(() => {
        state.processingTime++;
        if(!state.isWarningTimeReached && Date.now() >= state.warningDispTime){
          state.isShowSessionMsg = true;
          state.isWarningTimeReached = true;
        }
      }, 1000);

      context.root.$nextTick(() => {
        const separateWidth = (state.mainAreaWidth - state.separatorSize) / 2;
        const separateHeight = (state.mainAreaHeight - state.separatorSize) / 2;
        state.verticalLeftWidthPer = separateWidth / state.mainAreaWidth;
        state.verticalRightWidthPer = separateWidth / state.mainAreaWidth;
        state.horizonTopHeightPer = separateHeight / state.mainAreaHeight;
        state.horizonBottomHeightPer = separateHeight / state.mainAreaHeight;

        const saitenBoxArea = document.getElementById("saiten-box-area");
        state.scrollBarSize = saitenBoxArea.offsetWidth - saitenBoxArea.clientWidth;
        fitToImageArea();
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      state.isProcessingApi = false;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 切り出し画像Base64文字列をセット
     ************************************************************/

    const setBase64Image = (idx: number, base64Image: string) => {
      state.fieldActivities[idx].base64Image = base64Image;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ追加
     ************************************************************/

    const addScoreStamp = (point: Common.Point, score: number) => {
      if(!selectedFieldActivity.value){
        return;
      }
      selectedFieldActivity.value.scoreStamps.forEach(x => x.isActive = false);

      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = selectedFieldActivity.value.scoreStampIdx++;
      scoreStamp.x = point.x;
      scoreStamp.y = point.y;
      scoreStamp.height = 50;
      scoreStamp.width = `${score}`.length * scoreStamp.height / 2;
      scoreStamp.score = score;
      scoreStamp.color = "red";
      scoreStamp.isActive = true;
      selectedFieldActivity.value.scoreStamps.push(scoreStamp);

      calcScoreByScoreStamp(state.selectedIdx);

      state.isShowContextMenu = false;

      context.root.$nextTick(() => {
        scoreStamp.isActive = true;
      });
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteScoreStamp = (fieldActivityIdx: number, scoreStampIdx: number) => {
      state.fieldActivities[fieldActivityIdx].scoreStamps.splice(scoreStampIdx, 1);
      
      calcScoreByScoreStamp(fieldActivityIdx);
    }

    /************************************************************
     * 得点スタンプから得点・採点内容設定
     ************************************************************/

    const calcScoreByScoreStamp = (fieldActivityIdx: number) => {
      if(state.fieldActivities[fieldActivityIdx].scoreStamps.length == 0){
        // 削除した結果スタンプが0件になった場合、未採点に戻る
        state.fieldActivities[fieldActivityIdx].score = null;
        state.fieldActivities[fieldActivityIdx].correct_state = null;
      }else{
        // ベースとなる点数を取得 加点方式の場合は0点スタート、減点方式の場合は配点からスタート
        const baesScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 0 : state.currentSheetField.allot;

        let score = Common.sumArray(state.fieldActivities[fieldActivityIdx].scoreStamps.map(x => x.score)) + baesScore;
        // 0点を下限、配点を上限とする
        if(score < 0){
          score = 0;
        }else if(score > state.currentSheetField.allot){
          score = state.currentSheetField.allot;
        }

        let correct_state = null;

        if(score == state.currentSheetField.allot){
          // 配点以上の場合は正答
          correct_state = CorrectStateEnum.Seitou;
        }else if(score == 0){
          // 0点以下の場合は誤答
          correct_state = CorrectStateEnum.Gotou;
        }else{
          // 1点以上配点未満の場合は部分点(△)
          correct_state = CorrectStateEnum.Tokuten;
        }

        setCorrect(state.fieldActivities[fieldActivityIdx], correct_state, score);
      }
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      if(context.root.$store.state.fontSize != null){
        state.fontSize = context.root.$store.state.fontSize;
      }

      if(context.root.$store.state.lineHeight != null){
        state.lineHeight = context.root.$store.state.lineHeight;
      }

      await initialize();
      document.body.style.overflow = "hidden";
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("resize", adjustLayout);
      document.body.style.overflow = "";
      if(state.allowResetSaitenLock){
        await http.post(`/api/teacher/saiten_input/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    return {
      ...toRefs(state),
      DrawModeEnum,
      SaitenSortKindEnum,
      CorrectStateEnum,
      DirectionEnum,
      saitenBoxRef,
      modalCorrectImageRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      modalPreviewImageRef,
      carouselRef,
      setBase64Image,
      showPreviewImage,
      changeDrawMode,
      changeSortKind,
      clearCorrect,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      showModalCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      base64PreviewImages,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      changeSelectedIdx,
      scaleUp,
      scaleDown,
      fitToImageArea,
      selectedIdxUp,
      selectedIdxDown,
      updateCorrectState,
      addScoreStamp,
      deleteScoreStamp,
      showContextMenu,
      hideContextMenu,
      contextAreaStyle,
      contextButtonStyle,
      changeDrawModeBySaitenBox,
      contextMenuMouseDown,
      scale,
      fieldImageWidth,
      fieldWrapWidth,
      fieldImageHeight,
      fieldWrapHeight,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      changeDirection,
      saitenBoxAreaHeight,
      saitenBoxAreaWidth,
      correctImageStyle,
      selectedTensakuTextElemId,
      changeSelectedTensakuText,
      changeText,
      textFormatChanged,
      addTensakuText,
      deleteTensakuText,
    };
  }
});
